import React from 'react';

export const NotFound = () => {
  const year = new Date().getFullYear();
  return (
    <div className="abs-center wd-xl">
      <div className="text-center mb-4">
        <div className="text-lg mb-3">404</div>
        <p className="lead m-0">We couldn't find this page.</p>
        <p>The page you are looking for does not exists.</p>
      </div>
      <div className="p-3 text-center">
        <span className="mr-2">&copy;</span>
        <span>{year}</span>
        <span className="mx-2">-</span>
        <span>Vourity</span>
      </div>
    </div>
  );
};
